const section = document.querySelector('.footer-utilities');
if (section) {
  const sectionBg = section.querySelector('.section-background');
  const color = sectionBg ? getComputedStyle(sectionBg).backgroundColor : '';
  if (color && color !== 'rgba(0, 0, 0, 0)') {
    new IntersectionObserver(([entry]) => {
      if (entry) document.body.style.backgroundColor = entry.isIntersecting ? color : '';
    }, { threshold: 0 }).observe(section);
  }
}
